module.exports = __webpack_public_path__ + "img/logo-OST2-m.b6fb5d4.png";